import React from 'react';
import { Paper, ListItem, ListItemText } from '@mui/material';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { Right } from '../types/roles';

interface RightsDroppableListProps {
  rights: Right[];
  selectedRights: string[];
  droppableId: string;
  onSelectRight: (id: string) => void;
}

const RightsDroppableList: React.FC<RightsDroppableListProps> = ({
  rights,
  selectedRights,
  droppableId,
  onSelectRight,
}) => {
  const getDisplayText = (right: Right) => {
    return right.parent ? `${right.parent} ${droppableId === 'available' ? '➤' : '>'} ${right.name}` : right.name;
  };

  return (
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <Paper
          {...provided.droppableProps}
          ref={provided.innerRef}
          sx={{ height: 400, p: 2, overflowY: 'auto' }}
        >
          {rights.map((right, index) => (
            <Draggable key={right.id} draggableId={right.id} index={index}>
              {(provided) => (
                <ListItem
                  component="div"
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  onClick={() => onSelectRight(right.id)}
                  sx={{
                    mb: 1,
                    bgcolor: selectedRights.includes(right.id)
                      ? 'action.selected'
                      : (theme) => theme.palette.custom.listItemBackground,
                    cursor: 'pointer',
                  }}
                >
                  <ListItemText
                    primary={getDisplayText(right)}
                    secondary={right.description}
                    primaryTypographyProps={{ fontWeight: 'medium' }}
                  />
                </ListItem>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </Paper>
      )}
    </Droppable>
  );
};

export default RightsDroppableList;